import { useEffect } from 'react';

interface SchemaOrgProps {
  type: 'WebSite' | 'Organization' | 'Service' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    let schema: Record<string, unknown> = {
      '@context': 'https://schema.org',
      '@type': type,
    };

    if (type === 'WebSite') {
      schema = {
        ...schema,
        name: 'NOARE website',
        url: siteUrl,
        description: '飲食店・美容室向けのプロフェッショナルなWebサイト制作サービス',
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: `${siteUrl}/?s={search_term_string}`
          },
          'query-input': 'required name=search_term_string'
        }
      };
    } else if (type === 'Organization') {
      schema = {
        ...schema,
        name: 'NOARE website',
        url: siteUrl,
        logo: `${siteUrl}/vite.svg`,
        description: '飲食店・美容室向けのプロフェッショナルなWebサイト制作サービス',
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+81-90-8079-1727',
          contactType: 'Customer Service',
          email: 'ngszk0427@gmail.com',
          availableLanguage: 'Japanese'
        }
      };
    } else if (type === 'Service') {
      schema = {
        ...schema,
        name: 'Webサイト制作サービス',
        provider: {
          '@type': 'Organization',
          name: 'NOARE website'
        },
        serviceType: 'Webサイト制作',
        areaServed: 'JP',
        description: '飲食店・美容室向けのプロフェッショナルなWebサイト制作サービス。月額5,000円から始められ、最短当日で公開可能。',
        offers: [
          {
            '@type': 'Offer',
            name: 'ライトプラン',
            price: '5000',
            priceCurrency: 'JPY',
            description: 'ウェブサイトの作成、管理、お問い合わせフォーム管理、月4回の修正依頼、月1回の簡易アクセスレポート'
          },
          {
            '@type': 'Offer',
            name: 'スタンダードプラン',
            price: '10000',
            priceCurrency: 'JPY',
            description: 'ライトプランのすべて、カスタムドメイン、月8回の修正依頼、月2回のアクセスレポート、簡易SEO'
          },
          {
            '@type': 'Offer',
            name: 'プレミアムプラン',
            price: '15000',
            priceCurrency: 'JPY',
            description: 'スタンダードプランのすべて、月15回の修正依頼、構成・文章をヒアリングベースで設計、月1回の改善提案付きアクセスレポート、優先対応（48時間以内）'
          }
        ]
      };
    } else if (type === 'FAQPage' && data) {
      schema = {
        ...schema,
        mainEntity: data.questions || []
      };
    }

    const scriptId = `schema-${type}`;
    let scriptTag = document.getElementById(scriptId);
    
    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.id = scriptId;
      scriptTag.type = 'application/ld+json';
      document.head.appendChild(scriptTag);
    }
    
    scriptTag.textContent = JSON.stringify(schema);

    return () => {
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, [type, data]);

  return null;
}
